import { useState } from 'react';
import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/Dialog';
import { AudiencePage } from './AudiencePage';

interface Props {
  roomId: string;
}

/**
 * Quick in-app preview of the audience screen — for glancing at what the
 * audience sees without leaving the Control UI. Distinct from the
 * "Audience view" button in RoomControl, which opens a real separate
 * browser window so it can be dragged onto an actual projector/second
 * monitor; a same-window modal can never do that.
 */
export function AudienceViewDialog({ roomId }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" title="Quick in-app preview of the audience view">
          <Eye className="h-4 w-4" /> Preview audience view
        </Button>
      </DialogTrigger>
      <DialogContent className="h-[92vh] w-[96vw] max-w-[1800px] overflow-hidden">
        <DialogTitle className="sr-only">Audience view preview</DialogTitle>
        <div className="h-full overflow-auto rounded-lg">
          <AudiencePage roomId={roomId} rotated embedded />
        </div>
      </DialogContent>
    </Dialog>
  );
}
